const THIRTY_DAYS_SEC = 60 * 60 * 24 * 30

// Registrable domain the site and the app share; host-only elsewhere.
export function sharedCookieDomain(hostname: string): string | undefined {
  if (hostname === 'atm.com' || hostname.endsWith('.atm.com')) return 'atm.com'
  if (
    hostname === 'stage.atm-aws.com' ||
    hostname.endsWith('.stage.atm-aws.com')
  ) {
    return 'stage.atm-aws.com'
  }
  return undefined
}

export function readCookie(name: string): string | undefined {
  if (typeof document === 'undefined') return undefined
  const match = document.cookie
    .split('; ')
    .find((c) => c.startsWith(`${name}=`))
  if (!match) return undefined
  const raw = match.split('=').slice(1).join('=')
  try {
    return decodeURIComponent(raw)
  } catch {
    // A bad escape is the caller's malformed-value case, not a crash.
    return raw
  }
}

interface WriteCookieOptions {
  maxAgeSec?: number
  // Omitted = host-only.
  domain?: string
}

export function writeCookie(
  name: string,
  value: string,
  { maxAgeSec = THIRTY_DAYS_SEC, domain }: WriteCookieOptions = {},
) {
  if (typeof document === 'undefined') return
  const secure = location.protocol === 'https:' ? '; Secure' : ''
  const domainAttr = domain ? `; Domain=${domain}` : ''
  document.cookie = `${name}=${encodeURIComponent(value)}; Path=/; Max-Age=${maxAgeSec}; SameSite=Lax${secure}${domainAttr}`
}

// A vendor may have set it on any ancestor domain; expire it on all of them.
export function deleteCookie(name: string) {
  if (typeof document === 'undefined') return
  const parts = location.hostname.split('.')
  const domains: (string | undefined)[] = [undefined]
  for (let i = 0; i < parts.length - 1; i++) {
    domains.push(parts.slice(i).join('.'))
  }
  domains.forEach((domain) => writeCookie(name, '', { maxAgeSec: 0, domain }))
}
